<template>
  <div qaid="rail-customize-option" class="mb-4">
    <p
      v-if="subheading"
      :qaid="`rail-customize-option-description-${subheading}`"
      class="text-xs mb-2"
      v-html="subheading"
    />

    <div
      :class="['option-container', {['cursor-pointer']: navigatesToNewScreen || !isSelected}]"
      tabindex="0"
      @keyup.enter="handleAction"
      @click="handleAction"
    >
      <pdl-media-object qaid="rail-customize-option-media-object">
        <div slot="media" class="relative shadow">
          <img qaid="theme-template-image" :src="imageReference" />
          <span
            v-if="isSelected"
            qaid="theme-template-circular-check"
            class="flex absolute left-2 bottom-2 border border-gray-05 bg-white p-25 rounded-full"
          >
            <i qaid="theme-template-circular-check-icon" class="material-icons md-12 text-blue">done</i>
          </span>
        </div>

        <div slot="content" class="flex justify-between items-center h-full">
          <div>
            <h4
              :qaid="`theme-template-description-${choice.description}`"
              class="text-sm font-medium"
              v-html="choice.description"
            />
            <span
              v-if="hasDealerCostPriceDifference"
              qaid="theme-template-msrp"
              class="text-sm text-blue"
              v-html="choice.priceDifferenceDealerCost"
            />
            <span
              v-else-if="choice.priceDifferenceAdvertised && !isHidingPrices"
              qaid="theme-template-msrp"
              class="text-sm text-blue"
              v-html="choice.priceDifferenceAdvertised"
            />
          </div>

          <i v-if="navigatesToNewScreen" class="material-icons" qaid="theme-template-button" aria-hidden="true">
            arrow_forward
          </i>
        </div>
      </pdl-media-object>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {PdlMediaObject} from '@pedal/pdl-media-object';

export default {
  components: {PdlMediaObject},

  props: {
    choice: {
      type: Object,
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    actionFunction: {
      type: Function,
      default: null,
    },
    nextPresentationType: {
      type: String,
      default: null,
    },
    choiceId: {
      type: Number,
      default: 0,
    },
    parentGroupId: {
      type: Number,
      default: 0,
    },
    subheading: {
      type: String,
      default: null,
    },
    hasMultipleChoice: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    imageReference() {
      const fit = this.presentationType === 'CLR_SWATCH' ? 'stretch,1' : 'crop';
      const image =
        this.choice?.imageThumbnailReference && this.parentGroupId !== this.themeGroups?.SELECTED_THEME_ID // we need to display the default image for the Theme group (ID 9)
          ? `${this.baseImageUrl}${this.choice.imageThumbnailReference}`
          : this.defaultImgUrl;

      return `${image}?wid=80&hei=60&fit=${fit}`;
    },
    navigatesToNewScreen() {
      return Boolean(this.actionFunction && this.parentGroupId && this.nextPresentationType && this.hasMultipleChoice);
    },
    hasDealerCostPriceDifference() {
      return this.choice.priceDifferenceDealerCost && this.b2b && !this.consumerFriendlyMode && !this.isHidingPrices;
    },

    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['baseImageUrl', 'defaultImgUrl', 'isHidingPrices', 'themeGroups']),
  },

  methods: {
    handleAction() {
      if (this.parentGroupId === this.themeGroups?.SELECTED_THEME_ID) {
        this.$emit('go-back');
      } else if (this.navigatesToNewScreen) {
        this.actionFunction({
          groupId: this.parentGroupId,
          choiceId: this.choiceId,
          presentationType: this.nextPresentationType,
        });
      } else if (!this.isSelected) {
        this.actionFunction(this.choice);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.option-container {
  &:hover i,
  &:focus i {
    @apply text-blue;
  }
}
</style>
